import service from "@/utils/http";
// 新增浏览记录
export function addVistRecord(data){
    return service({
     url:'VirtualSimulationCourse/AddVistRecord',
     method:'post',
     data
    })
 }
 //获取浏览记录
export function VistRecord(data){
    return service({
     url:'VirtualSimulationCourse/MyCourseVistRecord',
     method:'post',
     data
    })
 }


// 获取用户信息
export function getadmin(data){
    return service({
     url:'User/GetModel',
     method:'post',
     data
    })
 }
 
 // 获取实验记录
export function ExperimentalResult(data){
    return service({
     url:'VirtualSimulationCourse/MyExperimentalResult',
     method:'post',
     data
    })
 }

//  获取实验记录详情
export function MyExperimentalResultStep(data){
    return service({
     url:'VirtualSimulationCourse/MyExperimentalResultStep',
     method:'post',
     data
    })
 }

 // 个人信息修改
export function adminUpdate(data){
    return service({
     url:'User/Update',
     method:'post',
     data
    })
 }


 // 修改头像
export function UpdateHeadImge(data){
    return service({
     url:'User/UpdateHeadImge',
     method:'post',
     data
    })
 }


// WEBPACK FOOTER //
// ./src/api/admin.js